import { SiaContext } from "Contexts/SiaContext";
import React, { useContext } from "react";

const useSiaContext = () => {
  return useContext(SiaContext);
};

export default useSiaContext;
